import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  Spinner,
} from "reactstrap";
import ContestFans from "./ContestFans";
import ContestAthletes from "./ContestAthletes";
import ContestSchools from "./ContestSchools";
import { useDispatch, useSelector } from "react-redux";
import { fetchContestOrganizer } from "store/actions/sportContestAction";
import Tabs from "components/Tabs";

const SportContestDetails = ({ showModal, handleModalToggle, contestId }) => {
  const dispatch = useDispatch();
  const { contestOrganizer } = useSelector((state) => state.contest);

  const [activeTab, setActiveTab] = useState("schools");
  const [isLoading, setIsLoading] = useState(false);

  const tabs = [
    {
      id: "schools",
      title: "Schools",
      content: activeTab === "schools" && (
        <ContestSchools contestId={contestId} />
      ),
      onClick: () => {},
    },
    {
      id: "athletes",
      title: "Athletes",
      content: activeTab === "athletes" && (
        <ContestAthletes contestId={contestId} />
      ),
      onClick: () => {},
    },
    {
      id: "fans",
      title: "Fans",
      content: activeTab === "fans" && <ContestFans contestId={contestId} />,
      onClick: () => {},
    },
  ];

  const toggleTab = (tabId) => {
    setActiveTab(tabId);
  };

  useEffect(() => {
    if (!showModal) {
      setActiveTab(tabs[0]?.id);
    } else {
      setIsLoading(true);
      dispatch(fetchContestOrganizer({ contestId })).finally(() =>
        setIsLoading(false)
      );
    }
  }, [showModal]);

  return (
    <Modal isOpen={showModal} centered toggle={handleModalToggle} size="xl">
      <ModalHeader closeButton>Contest Details</ModalHeader>
      {isLoading ? (
        <div className="text-center py-6">
          <Spinner color="primary" />
        </div>
      ) : (
        <>
          {contestOrganizer && (
            <div className="px-4 pt-2">
              <h3 className="text-underline">Contest Organizer</h3>
              <div className="d-flex align-items-center">
                <h4 className="mb-0 mr-2" style={{ opacity: 0.8 }}>
                  Name:
                </h4>
                <p style={{ fontWeight: 500 }} className="mb-0">
                  {contestOrganizer?.name}
                </p>
              </div>
              <div className="d-flex align-items-center">
                <h4 className="mb-0 mr-2" style={{ opacity: 0.8 }}>
                  Email:
                </h4>
                <p style={{ fontWeight: 500 }} className="mb-0">
                  {contestOrganizer?.email}
                </p>
              </div>
            </div>
          )}
          <ModalBody>
            <Card>
              <Tabs
                activeTab={activeTab}
                toggleTab={toggleTab}
                tabs={tabs}
                loader={false}
              />
            </Card>
          </ModalBody>
        </>
      )}
      <ModalFooter>
        <Button color="danger" onClick={handleModalToggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SportContestDetails;
